import * as utils from 'utils/funcUtils.js';
import { genExpression } from 'utils/generators';

// import { runCode, setEngine, setOptions, clearVariables, getVariables } from 'client-side-python-runner';

// let pythonInt = setEngine('skulpt');

// async function runPythonCode(code) {
//     if (!code) return { success: false, error: "No Code Provided" }
//     let error = false
//     let output = []
//     setOptions({
//         output: (o) => { output.push(o.replace(/\n$/, '')); console.log(" " + o) },
//         error: (e) => { error = e; console.warn("Python code execution error:", e, e.error) },
//         input: window.prompt,
//         pythonVersion: 3,
//         loadVariablesBeforeRun: true,
//         storeVariablesAfterRun: true,
//         onLoading: () => { console.log("_loading") },
//         onLoaded: () => { console.log("_loaded") },
//     });
//     await clearVariables()
//     console.warn("--- Python Execution Start ---")
//     await pythonInt
//     try {
//         await runCode(code);
//     } catch (e) {
//         console.error("Python Execution(not code) error", e)
//     }
//     console.warn("--- Python Execution End ---")
//     let vars = await getVariables()

//     if (!error) {
//         return { success: true, logs: output, vars: vars }
//     } else {
//         return { success: false, error: error }
//     }
// }


function outputMessage(success, message = "") {
    if (success) {
        return { success }
    } else {
        return { success, error: message }
    }
}

// export function checkEquals({ inputLogs }, { value, caseSensitive }) {
//     let equals = false
//     if (caseSensitive) {
//         equals = JSON.stringify(inputLogs) === JSON.stringify(value)
//     } else {
//         equals = JSON.stringify(inputLogs.toLowerCase()) === JSON.stringify(value.toLowerCase())
//     }
//     return outputMessage(equals, `The output did not match the answer`);
// }

// export function numberSequence({ inputLogs }, { start, end }) {
//     const expectedOutput = Array.from(
//         { length: Number(end) - Number(start) + 1 },
//         (_, i) => i + Number(start)
//     ).join("\n");

//     return outputMessage(JSON.stringify(inputLogs) === JSON.stringify(expectedOutput));
// }

// export async function randomRange({ inputCode, inputVars }, { min, max, count }) {
//     const results = new Set();

//     // for (let i = 0; i < count; i++) {
//     //     const {success, output} = runPythonCode(inputCode);
//     //     const number = utils.extractNumber(output);

//     //     if (number === null || number < min || number > max) {
//     //         return false;
//     //     }

//     //     results.add(number);
//     // }

//     // Indent each line of inputCode for correct Python syntax inside the loop
//     let indentedInputCode = inputCode
//         .split('\n')
//         .map(line => '  ' + line)
//         .join('\n');
//     let loopedInput = `for i in range(${count}):\n${indentedInputCode}`;

//     const { success, logs } = await runPythonCode(loopedInput);
//     if (!success) {
//         console.log("Error in running code:", logs);
//         return false;
//     }
//     const numbers = utils.extractNumbers(logs);


//     if (numbers.length === 0) return false;

//     for (const number of numbers) {
//         if (number < min || number > max) {
//             return false;
//         }
//         results.add(number);
//     }


//     const uniqueValues = Math.max(1, max - min + 1);
//     const threshold = uniqueValues > 100 ? Math.floor(uniqueValues * 0.6) : uniqueValues;

//     return outputMessage(results.size >= threshold);
// }

export function valCommentPresent({ inputCode }) {
    const lines = String(inputCode).split('\n');
    const commentRegex = /(?<!['"])#(?![^']*'|[^"]*")(.+)/;

    for (const line of lines) {
        if (commentRegex.test(line)) {
            return outputMessage(true);
        }
    }

    return outputMessage(false, "You must include a comment in your code.");
}

export function valCommentWithContent({ inputCode }) {
    const lines = String(inputCode).split('\n');
    // Match # that's not inside quotes, followed by optional whitespace, then at least one non-whitespace character
    const commentRegex = /(?<!['"])#(?![^']*'|[^"]*")\s*\S+/;

    for (const line of lines) {
        if (commentRegex.test(line)) {
            return outputMessage(true);
        }
    }

    return outputMessage(false, "You must include a comment with actual content (not just whitespace).");
}


export function variableValue({ inputVars }, { variable_name, value }) {
    if (variable_name in inputVars) {
        return outputMessage(inputVars[variable_name] === value);
    }
    return outputMessage(false);
}

export function typeCastingCheck({ inputCode, inputLogs, inputVars }, { variable_name, expected_type }) {
    if (!(variable_name in inputVars)) {
        return outputMessage(false, "Variable not found");
    }

    const validTypes = ['str', 'int', 'float', 'bool'];
    if (!validTypes.includes(expected_type)) {
        return outputMessage(false, "Only str, int, float, and bool type casting is supported");
    }

    const castingPattern = new RegExp(`${variable_name}\\s*=\\s*${expected_type}\\s*\\(`);
    if (!castingPattern.test(inputCode)) {
        return outputMessage(false,
            `You need to use the \`${expected_type}()\` function for type casting.\nExample: \`${variable_name} = ${expected_type}(value)\``
        );
    }

    const value = inputVars[variable_name];
    const typeMap = {
        'string': 'str',
        'number': Number.isInteger(value) ? 'int' : 'float',
        'boolean': 'bool'
    };

    const actualType = typeMap[typeof value];

    return outputMessage(
        actualType === expected_type,
        actualType === expected_type ?
            `Correct!` :
            `Type casting failed. Expected \`${expected_type}\`, but got \`${actualType}\``
    );
}

export function stringMethodCheck({ inputCode, inputLogs }, { method, value }) {
    const lastOutput = inputLogs.split('\n').filter(line => line.trim()).pop()?.trim();
    if (!lastOutput) return outputMessage(false, "No output found.");

    const methodRegex = new RegExp(`\\.${method}\\s*\\(\\s*\\)`);
    const valueRegex = new RegExp(`["']${value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}["']`, 'i'); // Case-insensitive

    const expectedOutput = method === 'upper' ? value.toUpperCase() : value.toLowerCase();

    if (!methodRegex.test(inputCode)) {
        return outputMessage(false, `Make sure to use the \`.${method}()\` method.`);
    }

    if (!valueRegex.test(inputCode)) {
        return outputMessage(false, "Make sure you're using the correct string value.");
    }

    return outputMessage(lastOutput === expectedOutput, lastOutput !== expectedOutput ? "Output doesn't match expected result." : "");
}

export function valStringSlicing({ inputCode }, { string, substring }) {
    // Match all variable slices with a colon (e.g. foo[1:5], bar[:], temp[x:y], etc.)
    const sliceRegex = /\b([a-zA-Z_][a-zA-Z0-9_]*)\s*\[\s*([^\]:]*)\s*:\s*([^\]]*)\s*\]/g;
    let match;
    let found = false;
    while ((match = sliceRegex.exec(inputCode)) !== null) {
        // Try to simulate the slice and see if it matches the substring
        let pyStr = string;
        let start = match[2].trim();
        let end = match[3].trim();
        let jsStart = start === '' ? undefined : Number(start);
        let jsEnd = end === '' ? undefined : Number(end);
        let s = jsStart;
        let e = jsEnd;
        if (typeof s === 'number' && s < 0) s = pyStr.length + s;
        if (typeof e === 'number' && e < 0) e = pyStr.length + e;
        if (s === undefined) s = 0;
        if (e === undefined) e = pyStr.length;
        let sliced = pyStr.slice(s, e);
        if (sliced === substring) {
            found = true;
            break;
        }
    }
    if (!found) {
        return outputMessage(false, 'You must use Python substring slicing (e.g. `variable[start:end]`)');
    }
    return outputMessage(true);
}

export function valStringSequence({ inputLogs }, { value, count }) {

    count = Number(count);
    // Normalize logs to array of lines
    console.log("inputLogs", inputLogs)
    const logs = Array.isArray(inputLogs)
        ? inputLogs
        : String(inputLogs).split('\n').filter(Boolean);

    console.log("logs", logs)

    // Count occurrences of the value
    const occurrences = logs.filter(line => line === value).length;

    // Check if every line matches value and count is correct
    const allMatch = logs.length === count && logs.every(line => line === value);

    console.log("allMatch", allMatch, logs.length, count, value, logs.every(line => line === value))

    let errMsg = "";
    if (!allMatch) {
        if (occurrences === 0) {
            errMsg = `The value \`${value}\` was not output at all.`;
        } else if (occurrences < count) {
            errMsg = `The value \`${value}\` was output ${occurrences} time(s), which is ${count - occurrences} too few.`;
        } else if (occurrences > count) {
            errMsg = `The value \`${value}\` was output ${occurrences} time(s), which is ${occurrences - count} too many.`;
        } else {
            errMsg = `The output did not match the expected sequence.`;
        }
    }

    return outputMessage(allMatch, errMsg);
}

export function valMatchesOperator({ inputCode }, { operator, right }) {
    if (!inputCode || !operator || !right) {
        return outputMessage(false, "No code or operator or right provided.");
    }

    // Remove whitespace for easier matching
    const code = Number(String(inputCode).replace(/\s+/g, ''));
    if (isNaN(code)) {
        return outputMessage(false, "Input code is not a valid number.");
    }

    right = Number(String(right)?.replace(/\s+/g, ''));
    if (isNaN(right)) {
        return outputMessage(false, "There was a server error, please try again with this question later.");
    }

    let result;
    try {
        switch (operator) {
            case "==": result = code == right; break;
            case "===": result = code === right; break;
            case "!=": result = code != right; break;
            case "!==": result = code !== right; break;
            case ">": result = code > right; break;
            case "<": result = code < right; break;
            case ">=": result = code >= right; break;
            case "<=": result = code <= right; break;
            case "and":
            case "&&": result = code && right; break;
            case "or":
            case "||": result = code || right; break;
            default:
                return outputMessage(false, `Unsupported operator: \`${operator}\``);
        }
    } catch (e) {
        return outputMessage(false, `Could not evaluate the expression.`);
    }

    if (result) {
        return outputMessage(true);
    } else {
        return outputMessage(false, `The expression \`${inputCode}\` does not evaluate to true.`);
    }
}


export function valExpressionEquals({ inputCode }, { expected, order = false }) {
    if (!inputCode || !expected) return false;

    // Remove all whitespace
    const normalize = expr => expr.replace(/\s+/g, '');

    // Canonicalize simple expressions: commutative (+, *), non-commutative (-, /)
    function canonical(expr) {
        if (typeof expr !== 'string') expr = String(expr);
        if (!expr) return expr;
        expr = normalize(expr);

        // Match binary expressions: e.g., 7+5, 10/2, 8-3, 4*7, count+1, 1+count
        const match = expr.match(/^([a-zA-Z_][a-zA-Z0-9_]*|\d+)([+\-*/])([a-zA-Z_][a-zA-Z0-9_]*|\d+)$/);
        if (match) {
            let [, a, op, b] = match;
            if (op === '+' || op === '*') {
                // Sort operands lexicographically for commutative operators
                return [a, b].sort().join(op);
            }
            // For non-commutative, keep order
            return `${a}${op}${b}`;
        }
        return expr;
    }

    // return canonical(inputCode) === canonical(expected);
    return outputMessage(
        order ? normalize(inputCode) === normalize(expected) : canonical(inputCode) === canonical(expected),
        `The expression \`${inputCode}\` is not equal to \`${expected}\``
    );
}

export function valVarEquals({ inputVars }, { variable, expected }) {
    if (!(variable in inputVars)) {
        return outputMessage(false, `Variable \`${variable}\` not found.`);
    }
    return outputMessage(
        inputVars[variable] === expected,
        inputVars[variable] === expected
            ? ""
            : `Variable \`${variable}\` value (\`${inputVars[variable]}\`) does not match expected (\`${expected}\`)`
    );
}


export function valEquals({ inputCode }, { expected, caseSensitive = true, trim = true, anyQuote = false, ignoreWhitespace = false }) {
    if (!inputCode || !expected) return false;

    let a = typeof inputCode === "string" ? inputCode : String(inputCode);
    if (trim && typeof a === "string") a = a.trim();
    if (!caseSensitive && typeof a === "string") a = a.toLowerCase();
    if (anyQuote) {
        // Replace all quotes with single quotes for comparison
        a = a.replace(/['"]/g, "'");
    }
    if (ignoreWhitespace) {
        a = a.replace(/(?<=\S)\s+(?=\S)/g, '');
    }

    const expectedList = Array.isArray(expected) ? expected : [expected];

    for (let item of expectedList) {
        let b = typeof item === "string" ? item : String(item);
        if (trim && typeof b === "string") b = b.trim();
        if (!caseSensitive && typeof b === "string") b = b.toLowerCase();
        if (anyQuote) {
            // Replace all quotes with single quotes for comparison
            b = b.replace(/['"]/g, "'");
        }
        if (ignoreWhitespace) {
            // Remove all whitespace for comparison
            b = b.replace(/(?<=\S)\s+(?=\S)/g, '');
        }
        if (a === b) return outputMessage(true, `The expression \`${inputCode}\` is equal to \`${b}\``);
    }

    return outputMessage(false, `The expression \`${inputCode}\` is not equal to \`${expected}\``);
}

export function valLogEquals({ inputLogs }, { expected, caseSensitive = true, trim = true, punctuation = true }) {
    // Normalize logs to arrays of strings
    const normalize = logs => {
        if (Array.isArray(logs)) return logs;
        return String(logs).split('\n').filter(Boolean);
    };

    let actual = normalize(inputLogs);
    let expectedNorm = normalize(expected);

    if (trim) {
        actual = actual.map(line => typeof line === "string" ? line.trim() : line);
        expectedNorm = expectedNorm.map(line => typeof line === "string" ? line.trim() : line);
    }
    if (!caseSensitive) {
        actual = actual.map(line => typeof line === "string" ? line.toLowerCase() : line);
        expectedNorm = expectedNorm.map(line => typeof line === "string" ? line.toLowerCase() : line);
    }
    if (!punctuation) {
        actual = actual.map(line => typeof line === "string" ? line.replace(/[!.]/g, "") : line);
        expectedNorm = expectedNorm.map(line => typeof line === "string" ? line.replace(/[!.]/g, "") : line);
    }

    // Check if arrays have same length
    if (actual.length !== expectedNorm.length) {
        return outputMessage(
            false,
            inputLogs.length ? "The above output does not match the expected result." : "Nothing was printed."
        );
    }

    // Compare line by line with numeric tolerance
    const equals = actual.every((line, i) => {
        const expectedLine = expectedNorm[i];

        // Try parsing both as numbers
        const actualNum = Number(line);
        const expectedNum = Number(expectedLine);

        // If both are valid numbers, compare numerically with tolerance
        if (!isNaN(actualNum) && !isNaN(expectedNum)) {
            // Use relative tolerance for larger numbers, absolute for small numbers
            const tolerance = Math.max(1e-10, Math.abs(expectedNum) * 1e-10);
            return Math.abs(actualNum - expectedNum) <= tolerance;
        }

        // Otherwise, compare as strings
        return line === expectedLine;
    });

    return outputMessage(
        equals,
        inputLogs.length ? "The above output does not match the expected result." : "Nothing was printed."
    );
}



export function valPrintsVariable({ inputCode }, { variable }) {
    if (!inputCode || !variable) return false;

    // Regex to match print statements with a variable
    const printRegex = new RegExp(`print\\s*\\(\\s*${variable}\\s*\\)`, 'g');

    // Check if the print statement is present in the code
    const found = printRegex.test(inputCode);

    return outputMessage(
        found,
        `The variable \`${variable}\` is not printed correctly.`
    );
}


export function valLineEquals({ inputCode }, { ...params }) {
    if (!inputCode) return false;

    const lines = inputCode.split('\n');

    const line = lines.findIndex(line => {
        let lineTest = valEquals({ inputCode: line }, { ...params });
        if (lineTest?.success) return true;
    });


    return outputMessage(
        line !== -1,
        `The code does not contain the expected line: \`${Array.isArray(params.expected) ? params.expected[0] : (params.expected || "")}\``
    );
}

export function valExpressionBoolean({ inputCode }, { expected }) {
    if (!inputCode || !expected) return false;

    if (inputCode.includes("true") || inputCode.includes("false")) {
        return outputMessage(false, "The expression is not a valid boolean.");
    }

    // Normalize any boolean-like strings to lowercase first letters in inputCode
    inputCode = String(inputCode).trim().toLowerCase();

    // run genExpression to calculte the input code as an expression, then check if its boolean value(accouting for like pythons uppercase and strings and stuff) is equal to the expected value
    const expression = genExpression({ expression: inputCode });
    if (expression === null) {
        return outputMessage(false, "The expression could not be evaluated.");
    }

    const actual = typeof expected === 'boolean' ? expected : String(expected).toLowerCase() === 'true';
    console.log("Expression:", expression, "Expected:", actual);

    return outputMessage(
        expression === actual,
        `The expression \`${inputCode}\` evaluates to \`${actual}\`, but expected \`${expected}\`.`
    );
}

export function valIncludes({ inputCode }, { expected, caseSensitive = true, ignoreWhitespace = false }) {
    if (!inputCode || expected == null) return false;

    inputCode = String(inputCode);

    if (ignoreWhitespace) inputCode = inputCode.replace(/\s+/g, '');
    if (!caseSensitive) inputCode = inputCode.toLowerCase();

    // always treat expected as an array
    const expectedArr = Array.isArray(expected) ? expected : [expected];

    const hasMatch = expectedArr.some(item => {
        let needle = String(item);
        if (ignoreWhitespace) needle = needle.replace(/\s+/g, '');
        if (!caseSensitive) needle = needle.toLowerCase();
        return inputCode.includes(needle);
    });

    return outputMessage(
        hasMatch,
        `The expression \`${inputCode}\` does not include ${expectedArr.map(e => `\`${e}\``).join(' or ')}.`
    );
}

export function valExcludes({ inputCode }, { expected, caseSensitive = true, ignoreWhitespace = false, anyQuote = false }) {
    if (!inputCode || expected == null) return false;

    inputCode = String(inputCode);

    if (ignoreWhitespace) inputCode = inputCode.replace(/\s+/g, '');
    if (!caseSensitive) inputCode = inputCode.toLowerCase();
    if (anyQuote) {
        // Replace all quotes with single quotes for comparison
        inputCode = inputCode.replace(/['"]/g, "'");
    }

    // always treat expected as an array
    const expectedArr = Array.isArray(expected) ? expected : [expected];

    const hasMatch = expectedArr.some(item => {
        let needle = String(item);
        if (ignoreWhitespace) needle = needle.replace(/\s+/g, '');
        if (!caseSensitive) needle = needle.toLowerCase();
        if (anyQuote) {
            // Replace all quotes with single quotes for comparison
            needle = needle.replace(/['"]/g, "'");
        }
        return inputCode.includes(needle);
    });

    return outputMessage(
        !hasMatch,
        `The expression should not include ${expectedArr.map(e => `\`${e}\``).join(' or ')}.`
    );
}

export function valLogIncludes({ inputLogs }, { expected, caseSensitive = true, ignoreWhitespace = false }) {
    if (!inputLogs || expected == null) return false;

    let logs = String(inputLogs);

    if (ignoreWhitespace) logs = logs.replace(/\s+/g, '');
    if (!caseSensitive) logs = logs.toLowerCase();

    // always treat expected as an array
    const expectedArr = Array.isArray(expected) ? expected : [expected];

    const hasMatch = expectedArr.some(item => {
        let needle = String(item);
        if (ignoreWhitespace) needle = needle.replace(/\s+/g, '');
        if (!caseSensitive) needle = needle.toLowerCase();
        return logs.includes(needle);
    });

    return outputMessage(
        hasMatch,
        `The output does not include ${expectedArr.map(e => `\`${e}\``).join(' or ')}.`
    );
}

export function valLineIncludes({ inputCode }, { expected, caseSensitive = true, ignoreWhitespace = false }) {
    if (!inputCode || expected == null) return false;

    const lines = inputCode.split('\n');
    const expectedArr = Array.isArray(expected) ? expected : [expected];

    const hasMatch = expectedArr.some(needle => {
        let needleStr = String(needle);
        if (!caseSensitive) needleStr = needleStr.toLowerCase();
        if (ignoreWhitespace) needleStr = needleStr.replace(/\s+/g, '');

        return lines.some(line => {
            let lineStr = String(line);
            if (!caseSensitive) lineStr = lineStr.toLowerCase();
            if (ignoreWhitespace) lineStr = lineStr.replace(/\s+/g, '');
            return lineStr.includes(needleStr);
        });
    });

    return outputMessage(
        hasMatch,
        `No line in the code includes ${expectedArr.map(e => `\`${e}\``).join(' or ')}.`
    );
}

/**
 * Validates Python code by running it with multiple test cases and checking outputs
 * Supports flexible output validation using simple strings or nested validators
 * 
 * @param {Object} valCustomParams - Contains inputCode from the user's submission
 * @param {Object} params - Configuration object
 * @param {Array} params.testCases - Array of test case objects, each with:
 *   - inputs: Array of string values to provide when code calls input()
 *   - expectedOutput: (optional) Simple string to match against output
 *   - outputCheck: (optional) Single validator config { func: "validatorName", params: {...} }
 *   - outputChecks: (optional) Array of validator configs (all must pass)
 * 
 * @example
 * // Simple string matching
 * valWithInputs(ctx, {
 *   testCases: [
 *     { inputs: ["5"], expectedOutput: "12" }
 *   ]
 * })
 * 
 * @example
 * // Using nested validators
 * valWithInputs(ctx, {
 *   testCases: [
 *     { 
 *       inputs: ["5"],
 *       outputCheck: { func: "valIncludes", params: { expected: "plus 5 was" } }
 *     }
 *   ]
 * })
 * 
 * @example
 * // Multiple validators
 * valWithInputs(ctx, {
 *   testCases: [
 *     {
 *       inputs: ["Alice", "25"],
 *       outputChecks: [
 *         { func: "valIncludes", params: { expected: "Hello Alice" } },
 *         { func: "valVarEquals", params: { variable: "age", expected: 25 } }
 *       ]
 *     }
 *   ]
 * })
 */
export async function valWithInputs(valCustomParams, { testCases }) {
    if (!testCases || !Array.isArray(testCases) || testCases.length === 0) {
        return outputMessage(false, "No test cases provided");
    }

    // Dynamic import to avoid circular dependency issues
    const { runPythonCode } = await import('./pythonRunner.js');

    // Get reference to all validators for nested validation
    const validators = {
        valCommentPresent,
        valCommentWithContent,
        variableValue,
        typeCastingCheck,
        stringMethodCheck,
        valStringSlicing,
        valStringSequence,
        valMatchesOperator,
        valExpressionEquals,
        valVarEquals,
        valEquals,
        valLogEquals,
        valPrintsVariable,
        valLineEquals,
        valExpressionBoolean,
        valIncludes,
        valExcludes,
        valLogIncludes,
        valLineIncludes
    };

    for (let i = 0; i < testCases.length; i++) {
        const testCase = testCases[i];
        const inputs = testCase.inputs || [];

        // Format inputs for error messages
        const inputsDisplay = inputs.length > 0
            ? `inputs: ${inputs.map(inp => `\`${inp}\``).join(', ')}`
            : 'no inputs';

        // Run the user's code with the test inputs
        const result = await runPythonCode(valCustomParams.inputCode, inputs);

        // Check for execution errors
        if (!result.success) {
            // Extract clean error message
            let errorMsg = result.error;
            if (typeof errorMsg === 'object' && errorMsg !== null) {
                errorMsg = errorMsg.message || errorMsg.error || JSON.stringify(errorMsg);
            }
            errorMsg = String(errorMsg);

            return outputMessage(false, errorMsg);
        }

        // Build context for validator calls (matching TextBox format)
        const testContext = {
            inputCode: valCustomParams.inputCode,
            inputLogs: result.logs.join("\n"), // Join like TextBox does
            inputVars: result.vars
        };

        // Validate output using one of three modes:

        // Mode 1: Simple string comparison
        if (testCase.expectedOutput !== undefined) {
            const outputStr = result.logs.join("\n").trim();
            const expectedStr = String(testCase.expectedOutput).trim();

            if (outputStr !== expectedStr) {
                return outputMessage(false,
                    `Code ran with ${inputsDisplay}: expected \`${expectedStr}\` but got \`${outputStr}\``
                );
            }
        }

        // Mode 2: Single validator check
        else if (testCase.outputCheck) {
            const validatorFn = validators[testCase.outputCheck.func];
            if (!validatorFn) {
                return outputMessage(false,
                    `Code ran with ${inputsDisplay}: Unknown validator function '${testCase.outputCheck.func}'`
                );
            }

            const checkResult = validatorFn(testContext, testCase.outputCheck.params || {});
            if (!checkResult.success) {
                return outputMessage(false, `Code ran with ${inputsDisplay}: ${checkResult.error}`);
            }
        }

        // Mode 3: Multiple validator checks (all must pass)
        else if (testCase.outputChecks && Array.isArray(testCase.outputChecks)) {
            for (const check of testCase.outputChecks) {
                const validatorFn = validators[check.func];
                if (!validatorFn) {
                    return outputMessage(false,
                        `Code ran with ${inputsDisplay}: Unknown validator function '${check.func}'`
                    );
                }

                const checkResult = validatorFn(testContext, check.params || {});
                if (!checkResult.success) {
                    return outputMessage(false, `Code ran with ${inputsDisplay}: ${checkResult.error}`);
                }
            }
        }

        // No validation mode specified - just check that it ran successfully
    }

    return outputMessage(true);
}

